import React, { useEffect, useState } from "react";
import { Drawer } from "@material-ui/core";
import styled from "styled-components/macro";
import _ from "lodash";
import { ButtonIcon, ButtonText } from "@loanbossinc/component-library";

import "./filterDrawer.css";
import { defaultFilterState } from "../constants";

import FilterDrawerEntityCard from "./filterDrawerEntityCard";
import FilterDrawerFrequencyCard from "./filterDrawerFrequencyCard";
import FilterDrawerReportAssigneeDropdown from "./filterDrawerReportAssigneeDropdown";
import FilterDrawerReportStatusCard from "./filterDrawerReportStatusCard";
import FilterDrawerTaskAssigneeDropdown from "./filterDrawerTaskAssigneeDropdown";

const DrawerHeader = styled.div`
  background-color: #ffffff;
  display: flex;
  margin-bottom: 7px;
  outline: 1px solid #dadce0;
  padding: 5px;
  height: 50px;
  align-items: center;
`;

const StyledButtonText = styled(ButtonText)`
  && {
    background-color: #005aa9;
    color: #ffffff;
    height: 36px;
    margin-left: 75px;
    width: 118px;

    &:hover {
      background-color: #004589;
    }
  }
`;

const FilterDrawer = props => {
  const { closeDrawer, isOpen, taskAssignees, reportAssignees, setDrawerFilterState, drawerFilterState } = props;
  const [copyFilterState, setCopyFilterState] = useState({});

  useEffect(() => {
    const copy = _.cloneDeep(drawerFilterState);
    setCopyFilterState(copy);
  }, [drawerFilterState]);

  const updateFilterState = (type, value) => {
    const updatedFilterState = {
      ...copyFilterState,
      [type]: value
    };
    setCopyFilterState(updatedFilterState);
  };

  const revertToDefault = () => {
    setCopyFilterState(defaultFilterState);
  };

  const applyFilters = () => {
    setDrawerFilterState(copyFilterState);
    closeDrawer();
  };

  const handleUnsavedChanges = () => {
    const copy = _.cloneDeep(drawerFilterState);
    setDrawerFilterState(copy);
    closeDrawer();
  };

  return (
    <Drawer
      BackdropProps={{ invisible: "true" }}
      anchor={"right"}
      className="filter-drawer-container"
      disableBackdropTransition
      onClose={handleUnsavedChanges}
      open={isOpen}
    >
      <DrawerHeader>
        <ButtonIcon iconName="clear" style={{ color: "#C40A0A" }} onClick={() => handleUnsavedChanges()} />
        <ButtonText label="Revert to default" style={{ marginLeft: "5px" }} onClick={() => revertToDefault()} />
        <StyledButtonText label="Done" variant="contained" onClick={() => applyFilters()} />
      </DrawerHeader>
      <FilterDrawerReportAssigneeDropdown reportAssignees={reportAssignees} copyFilterState={copyFilterState} updateFilterState={updateFilterState} />
      <FilterDrawerTaskAssigneeDropdown taskAssignees={taskAssignees} copyFilterState={copyFilterState} updateFilterState={updateFilterState} />
      <FilterDrawerFrequencyCard copyFilterState={copyFilterState} updateFilterState={updateFilterState} />
      <FilterDrawerEntityCard copyFilterState={copyFilterState} updateFilterState={updateFilterState} />
      <FilterDrawerReportStatusCard copyFilterState={copyFilterState} updateFilterState={updateFilterState} />
    </Drawer>
  );
};

export default FilterDrawer;
